module.exports = __webpack_public_path__ + "static/img/store-car-null_light.264878ff.png";